import React from 'react';
import { useTranslation } from 'react-i18next';

import { Report } from 'types';
import { ReportDates, ReportFiscalYear, ReportModalContent } from '..';
import { reports } from '../../hooks';

interface ReportModalContentSwitchProps {
  report: Report;
  handleSubmit: () => void;
}

export const ReportModalContentSwitch: React.FC<ReportModalContentSwitchProps> = ({
  handleSubmit,
  report,
}) => {
  const { t } = useTranslation('report_modal');

  return report.name === reports.annualDfi ? (
    <ReportModalContent
      titleText={t('select_financial_year', 'Select financial year')}
      subTitleText={t('summary_financial_year', 'Select the financial year you wish to view')}
    >
      <ReportFiscalYear onSubmit={handleSubmit} />
    </ReportModalContent>
  ) : (
    <ReportModalContent
      titleText={t('select_date_range', 'Select date range')}
      subTitleText={t('summary_date', 'Select a time period you wish to run your report for')}
    >
      <ReportDates onSubmit={handleSubmit} />
    </ReportModalContent>
  );
};
